const validateToken = async () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return { valid: false };

    // Verify token with backend
    const response = await fetch(`${process.env.REACT_APP_API_PATH}api/auth/verify`, {
    // const response = await fetch("http://localhost:5001/api/auth/verify", {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`
      }
    });
    const data = await response.json();

    if (!response.ok) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      return { valid: false };
    }
    const premium = data?.user?.premium;
    console.log("resaponse", data);
    console.log("PREMIUMMMM", premium);
    return { valid: true, premium };

  } catch (error) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    return { valid: false };
  }
};

export const isAuthenticated = async () => {
  return await validateToken();
}; 
